import "cross-fetch/polyfill";
import RiotBarLoader from "./loader";
import useAuthState from "./hooks/use-auth-state";
export { useAuthState };
export default RiotBarLoader;
